import { memo } from "react";

import { QuestionCancelPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/cancel-policy";

import { useDayTripPlanCancelPolicy } from "./hooks";

export const QuestionDayTripPlanCancelPolicy = memo(() => {
	const {
		cancelPolicy,
		useBaseCancelPolicy,
		toggleUseBaseCancelPolicy,
		append,
		removeCancelPolicyByIndex,
		beforeDaysOptions,
		updateBeforeDays,
		chargeRatioOptions,
		updateChargeRatio,
	} = useDayTripPlanCancelPolicy();

	const guide = `日帰りプラン独自のキャンセルポリシーが設定できます。<br />`;

	return (
		<QuestionCancelPolicy
			cancelPolicy={cancelPolicy}
			useBaseCancelPolicy={useBaseCancelPolicy}
			toggleUseBaseCancelPolicy={toggleUseBaseCancelPolicy}
			appendCancelPolicy={append}
			removeCancelPolicy={removeCancelPolicyByIndex}
			cancelPolicyBeforeDaysOptions={beforeDaysOptions}
			changeCancelPolicyBeforeDays={updateBeforeDays}
			cancelPolicyChargeRatioOptions={chargeRatioOptions}
			changeCancelPolicyChargeRatio={updateChargeRatio}
			hasError={cancelPolicy?.hasError}
			isEdited={cancelPolicy?.isEdited}
			guide={guide}
		/>
	);
});

QuestionDayTripPlanCancelPolicy.displayName = "QuestionDayTripPlanCancelPolicy";
